<router-outlet></router-outlet>
<app-spinner [visible]="showSpinner"></app-spinner>

